import React from 'react';
import { Link } from 'react-router-dom';
import { BoostaBolt } from '@/components/BoostaBolt';

export const MarketingFooter = () => (
  <footer className="border-t border-white/5 py-12 px-4 md:px-8 text-sm text-white/45">
    <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
      <div className="flex items-center gap-2">
        <BoostaBolt size={24} />
        <span className="font-display font-bold text-white text-3d">Boosta</span>
        <span className="ml-3 text-xs">© {new Date().getFullYear()} · Built in the UK</span>
      </div>
      <div className="flex gap-6 text-xs uppercase tracking-wider">
        <Link to="/#features" className="hover:text-white">Features</Link>
        <Link to="/#pricing" className="hover:text-white">Pricing</Link>
        <Link to="/blog" className="hover:text-white" data-testid="footer-blog">Blog</Link>
        <Link to="/contact" className="hover:text-white" data-testid="footer-support">Support</Link>
        <Link to="/login" className="hover:text-white">Sign in</Link>
      </div>
    </div>
  </footer>
);

export default MarketingFooter;
